module.exports = __webpack_public_path__ + "media/images/phone/writer-offering-idea-plot-selection-flow-acf8f914ced218d763ebf254bc50da52.png";